import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MainPageLayout from "../../../layout/MainPageLayout";
import { VHEICLE_READINGS_HISTORY } from "../apiEndPoints";
import { VEHICLE_READING_COLUMNS } from "../utils/ComplaintsTables.config";
import useGetHistory from "../../../CustomHooks/useAxios/useGetHistory";
import DialogBox from "../../../components/UI/DialogBox";
import { handleErrMessage } from "../../../functions/handleErrMessage";
import { setError } from "../../../redux/dataSlice";
import LoadingDisplay from "../../../components/UI/LoadingDisplay";
import { endDate, getDateBefore } from "../../../helpers/dateHelpers";
import { DateFilters } from "../../../components/Filter/dateFilters/DateFilters";
import { VehicleReadingTable } from "../components/vehicleReadingList/VehicleReadingTable";
import SearchTable from "../../../components/common/SearchTable";
import {
  VEHICLE_READING_SEARCH_OPTIONS,
  VEHICLE_READING_FILTERS_OPTIONS,
} from "../utils/complaintFilter.config";
import { formatVehicleReadingslData } from "../utils/excelFormatters";
import ExportButton from "../../../components/exportExcel/ExportButton";
import VehicleReadingDialog from "../components/dialogs/VehicleReadingDialog";
import FilterData from "../../../components/Filter/FilterData";

export const VehicleReadingsPage = () => {
  const [dateRange, setDateRange] = useState({
    start: "",
    end: "",
    currentSelector: "lastMonth",
  });
  const [openDialog, setOpenDialog] = useState({
    openView: false,
  });
  const fromDate = getDateBefore(30);
  const { getHistory, historyLoaded, isSucceed } = useGetHistory();
  const dispatch = useDispatch();
  const data = useSelector((state) => state.data.data);
  const originalData = useSelector((state) => state.data.copyData);
  const historyError = useSelector((state) => state.data.error);
  const historyErrMsg = useSelector((state) => state.data.errMessage);
  const dataLength =
    !historyLoaded && !historyErrMsg && isSucceed ? data.length : 0;
  const checkedOriginalData =
    !historyLoaded && !historyErrMsg && isSucceed ? originalData : [];

  // ...............get  excel data............
  const excelData = formatVehicleReadingslData(checkedOriginalData);
  const excelConfig = {
    data: excelData,
    fileName: "Vehicles_Readings_Report",
    sheetName: "Vehicles Readings",
  };

  useEffect(() => {
    getHistory(`${VHEICLE_READINGS_HISTORY}/${fromDate}/${endDate}`);
  }, []);

  return (
    <MainPageLayout
      headerConfig={{ title: "Vehicle Readings" }}
      numberOfData={dataLength}
      bgColor="bg-[#f0f2f7]"
    >
      <DateFilters
        dateRange={dateRange}
        setDateRange={setDateRange}
        getHistory={getHistory}
        baseUrl={VHEICLE_READINGS_HISTORY}
        loaded={historyLoaded}
      />
      {historyLoaded ? (
        <LoadingDisplay height="h-[80vh] mt-2" />
      ) : (
        isSucceed && (
          <>
            <div className="flex justify-between pt-2">
              <div className="flex">
                <SearchTable
                  searchCategories={VEHICLE_READING_SEARCH_OPTIONS}
                  placeholder="Search by vehicle"
                />
                <FilterData categories={VEHICLE_READING_FILTERS_OPTIONS} />
              </div>
              <ExportButton excelConfig={excelConfig} />
            </div>
            <VehicleReadingTable
              columns={VEHICLE_READING_COLUMNS}
              tableHeight="h-[calc(100vh-13em)] max-lg:h-[calc(100vh-11em)] max-md:h-[calc(100vh-11em)]"
              showStatus={true}
              setOpenDialog={setOpenDialog}
            />
          </>
        )
      )}
      {historyError && (
        <DialogBox
          title="Error"
          btnText="Ok"
          message={handleErrMessage(historyErrMsg)}
          closeAction={() => dispatch(setError("false"))}
        />
      )}
      {openDialog.openView && (
        <VehicleReadingDialog
          details={openDialog.data}
          closeDialog={() => setOpenDialog({ openView: false })}
        />
      )}
    </MainPageLayout>
  );
};
